// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__15Jx7","legacyBtn":"MutateMid_legacyBtn__2a-GI"};